export const getPagination = ({ pagination }) => pagination;


